import _ from 'lodash';

import { GetBalance, GetTerminalBalance } from './selectors';
import { store } from '../index/terminalApp';
import { SetBalance } from '../actions/terminal';

export const getBalance = (balances = {}, defaultToZero = true) => {
  const state = store.getState();
  const terminalBalance = balances.terminalBalance ?? GetTerminalBalance(state);
  const userBalance = balances.userBalance ?? GetBalance(state);

  if (userBalance || userBalance === 0) return userBalance;

  if (!_.isNil(terminalBalance)) return terminalBalance;

  return defaultToZero ? 0 : null;
};

export const setBalanceToTerminal = (() => {
  let previousBalance = null;

  return (balance) => {
    if ((balance || balance === 0) && (previousBalance === null || previousBalance !== balance)) {
      store.dispatch(SetBalance(balance));
    }

    previousBalance = balance;
  };
})();
